<div class="w-full">
    <div class="flex justify-between items-center border-b border-b-gray-300 zuper-dialog-header">
      <h6 mat-dialog-title class="font-semibold primary-font">{{ 'text.delete.phase' | translate }}</h6>
    </div>
    <div class="flex flex-col">
      <div class="w-full">
        <div class="zuper-dialog-body">
          <div class="w-full primary-font text-base">
            <p class="mb-4">{{ 'text.phase.delete' | translate }}</p>
            <div class="mb-4 flex items-center">
              <input type="radio" id="option1" name="options" class="mr-2" [(ngModel)]="selectedOption" value="1">
              <label for="option1" class="font-base">{{ 'text.phase.delete.option1' | translate }}</label>
            </div>
  
            <!-- Radio Button 2 -->
            <div class="mb-4 flex items-center">
              <input type="radio" id="option2" name="options" class="mr-2" [(ngModel)]="selectedOption" value="2">
              <label for="option2" class="font-base">{{ 'text.phase.delete.option2' | translate }}</label>
            </div>
          </div>
        </div>
        <div class="flex justify-end border-t border-gray-300 zuper-dialog-footer">
          <div class="space-x-3">
            <button mat-stroked-button [mat-dialog-close]="" class="btn-small px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none" type="button">{{ 'cancel.text' | translate }}</button>
            <button mat-stroked-button class="btn-small bg-primary px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-white text-base font-medium rounded-md text-white-600 focus:outline-none" (click)="proceedDelete()">{{ 'proceed' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  